var direction = ['up', 'down', 'left', 'right'];
var variant = ['primary', 'secondary'];

export { direction, variant };
